module.exports = __webpack_public_path__ + "img/car-park-control-1.4ecc1d25.png";